import { onMounted, onUnmounted } from "vue";

export function useVueEffect(effect: () => () => void) {
  let remove: () => void;
  onMounted(() => {
    remove = effect();
  });
  onUnmounted(() => {
    remove?.();
  });
}
